import authorizedRoutes from "~/helpers/authorized_routes.json"

export default async function ({ store, route, params }) {
  if (
    store.getters["user/IS_BAND"] &&
    !authorizedRoutes.some((r) => route.path.includes(r)) &&
    !route.path.includes(`/draft/${params.id}/`)
  ) {
    try {
      await store.dispatch("draft/RESET_CURRENT")
    } catch (error) {
      console.log(error)
    }
  }
}
